const STORAGE_PREFIX = "nextvial_order_submitted_";
const inFlight = new Set();
const completed = new Set();

function storageKey(paymentToken) {
  return `${STORAGE_PREFIX}${paymentToken}`;
}

export function wasOrderSubmissionCompleted(paymentToken) {
  if (!paymentToken) return false;
  if (completed.has(paymentToken)) return true;
  try {
    return sessionStorage.getItem(storageKey(paymentToken)) === "1";
  } catch {
    return false;
  }
}

/** Returns false if this payment token is already submitting or submitted. */
export function tryBeginOrderSubmission(paymentToken) {
  if (!paymentToken) return false;
  if (inFlight.has(paymentToken) || completed.has(paymentToken)) return false;
  if (wasOrderSubmissionCompleted(paymentToken)) return false;

  inFlight.add(paymentToken);
  return true;
}

export function completeOrderSubmission(paymentToken) {
  if (!paymentToken) return;
  inFlight.delete(paymentToken);
  completed.add(paymentToken);
  try {
    sessionStorage.setItem(storageKey(paymentToken), "1");
  } catch {
    /* ignore */
  }
}

export function failOrderSubmission(paymentToken) {
  if (!paymentToken) return;
  inFlight.delete(paymentToken);
}
